import Warn from '@assets/icons/warn.svg'
import { Icon } from './Icon'

export const WarnIcon = Icon(Warn)
